import { iSession } from "../../interfaces/session";

const SESSION: iSession = {
    route: 'main',
    professions: [],
}

export default SESSION;